<template>
    <sweet-modal :title="$t('general_createNewFile')" blocking ref="createNewFileModal" class="modal" v-on:close="close">
        <el-form :model="form" ref="formCreate" class="tf-form" status-icon :rules="rulesCreate" label-width="0" inline>
            <el-form-item style="flex: 1" prop="name">
                <el-input :label="$t('modal_files_fileName')" style="width: 100%" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item prop="fileType">
                <el-radio-group class="tf-radio__group" v-model="form.fileType">
                    <el-radio class="tf-radio" label="docx"><img src="@/assets/img/icons/microsoft-word.png" width="50" height="50"/></el-radio>
                    <el-radio class="tf-radio" label="xlsx"><img src="@/assets/img/icons/microsoft-excel.png" width="50" height="50"/></el-radio>
                    <el-radio class="tf-radio" label="pptx"><img src="@/assets/img/icons/microsoft-powerpoint.png" width="50" height="50"/></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item class="modal__btn" style="float:right;">
                <el-button @click="createNewFile('formCreate')" type="primary">{{$t('general_createNewFile')}}</el-button>
            </el-form-item>
        </el-form>
    </sweet-modal>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "CreateNewFileModal",
    components: {
      SweetModal
    },
    data (){
      return {
        selectedRow: {},
        type: '',
        form: {
          name: null,
          fileType: 'docx'
        },
        rulesCreate: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods:{
      openModal(selectedRow, type){
        this.selectedRow = selectedRow;
        this.type = type;
        this.$refs.createNewFileModal.open();
      },
      async createNewFile(form){
        const status = await this.checkStatus()
        if (!status) {
          return this.notification("Notification", 'To have the ability for parallel creation and editing of office documents, purchase the appropriate subscription.', "info")
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            console.log(this.selectedRow);
            const data = {
              name: this.form.name,
              fileType: this.form.fileType,
              oldParentId: null
            };
            switch (this.type){
              case 'projectTask':
                data.entityId = this.selectedRow.id
                data.taskId = this.selectedRow.id;
                data.historyEntityId = this.$route.query.projectId
                data.entityTypeId = 27
                // data.type = 'project';
                // data.mainType = 'task';
                break;
              case 'project':
                data.entityId = this.selectedRow.projectId;
                data.historyEntityId = this.$route.query.projectId
                data.taskId = null;
                data.entityTypeId = 3;
                // data.type = 'project';
                // data.mainType = 'project';
                break;
              case 'businessUnit':
                data.entityId = this.selectedRow.businessUnitId;
                data.historyEntityId = this.selectedRow.businessUnitId
                data.taskId = null;
                data.entityTypeId = 19;
                // data.type = 'bu';
                // data.mainType = 'project';
                break;
              case 'businessUnitTask':
                data.entityId = this.selectedRow.id;
                data.taskId = this.selectedRow.id;
                data.historyEntityId = this.selectedRow.id;
                data.entityTypeId = 45;
                // data.type = 'bu';
                // data.mainType = 'task';
                break;
              case 'engagementTask':
                data.entityId = this.selectedRow.engagementId;
                data.taskId = this.selectedRow.id;
                data.historyEntityId = this.selectedRow.id;
                data.entityTypeId = 37
                // data.type = 'engagement';
                // data.mainType = 'task';
                break;
              case 'engagement':
                data.entityId = this.selectedRow.engagementId;
                data.taskId = null;
                data.historyEntityId = this.selectedRow.engagementId;
                data.entityTypeId = 11
                // data.type = 'engagement';
                // data.mainType = 'project';
                break;
            }
            this.create(data)
          }
        });
      },
      async checkStatus() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/entityFiles/checkUserCount?companyId=${this.$route.query.companyId}`)
        return data.success
      },
      create(data){
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/entityFiles/createNewFile?companyId=${this.$route.query.companyId}`, data)
          .then(async response => {
            switch (this.type) {
              case 'projectTask' :
                await this.$store.dispatch('getTaskFiles', this.selectedRow.id);
                break;
              case 'project':
                await this.$store.dispatch('getProjectFiles');
                break;
              case 'businessUnitTask':
                await this.$store.dispatch('getDepTaskFiles', this.selectedRow.id);
                break;
              case 'businessUnit':
                await this.$store.dispatch('getBusinessUnitFiles');
                break;
              case 'engagementTask':
                await this.$store.dispatch('getCasTaskFiles', this.selectedRow.id);
                break;
              case 'engagement':
                await this.$store.dispatch('getEngagementFiles');
                break;
            }
            loader.hide()
            await this.$emit('openCreatedFile', response.data.fileData);
            this.$refs.createNewFileModal.close();
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      close(){
        this.selectedRow = {};
        this.type = '';
        this.$refs['formCreate'].resetFields();
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
.tf-form {
  display: flex;
  align-items: center;
  width:100%;
  /deep/.el-form-item {
    .el-form-item__content {
      width: 100%;
    }
  }
  .tf-radio__group {
    display: flex;
    align-items: center;
    .tf-radio {
      display: flex;
      align-items: center;
    }
  }
}

</style>
